import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from 'mui-modal-provider';

import { Button } from '../../../../common/button-new';
import { ConsultationButtonProps } from './consultation-button.models';
import { ConsultationModal } from '../consultation-modal';
import { ensureAbsoluteUrl } from '../../../../../utils';
import { pushEcpLocatorEvent } from '../../../../../utils/analytics/push-ecp-locator-event';
import { EcpLocatorEvent } from '../../../../../models/ya-metrica-events';

export const ConsultationButton = ({ phone, website, code }: ConsultationButtonProps): JSX.Element => {
  const { showModal } = useModal();
  const handleClick = (): void => {
    showModal(ConsultationModal,  { phone, code });
  };

  const handleConsultationLinkClick = useCallback(() => {
    if (code) {
      pushEcpLocatorEvent(EcpLocatorEvent.CataractRequestConsulting, code);
    }
    // Allow dataLayer event to be processed before navigation
    if (website) {
      setTimeout(() => {
        window.open(ensureAbsoluteUrl(website), '_blank', 'noopener,noreferrer');
      }, 0);
    }
  }, [code, website]);

  return (
    <>{website ? (
      <Button
        testId="consultation-link"
        style="darker"
        onClick={handleConsultationLinkClick}
      >
        <FormattedMessage id="ecp.cataract.button" />
      </Button>
    ) : (
      <Button
        testId="consultation-button"
        style="darker"
        onClick={handleClick}
      >
        <FormattedMessage id="ecp.cataract.button" />
      </Button>
    )}</>
  );
};
